import { render, staticRenderFns } from "./home.vue?vue&type=template&id=ed5c48fc&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=ed5c48fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5c48fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed5c48fc')) {
      api.createRecord('ed5c48fc', component.options)
    } else {
      api.reload('ed5c48fc', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=ed5c48fc&scoped=true&", function () {
      api.rerender('ed5c48fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/home.vue"
export default component.exports